module.exports = __webpack_public_path__ + "static/immolation-6a5009c1866dfc15b15331dbc5ac929f.jpg";